<template>
    <div class="order-details" id="subOutputRank-print1">
        <div class="loading" style="text-align: center">
            <Loading :isLoading="isLoading"></Loading>
        </div>
        <div class="order-details-in" v-if="!isLoading">
            <div class="left">
                <div class="state">
                    <div>
                    	<div class="to-print-btn" @click="printBtn" v-if="!isPrint">
                            <i class="iconfont icon-print"></i> 打印预订单
                        </div>
                        <!-- <img :src="qr" alt="" class="logo-od-qr" /> -->
                        <div class="logo">
                            <img src="../../../assets/img/cnbookinglog.png" height="39" width="100" style="margin-right: 10px"/>
                            <img src="../../../assets/img/logo-cn.png" height="36" width="161"/></div>
                        </div>
                    <div class="link"></div>
                    <div class="info">
                        <div class="orderNo" style="display:flex">
                            <div class="icon-box" >
                                <i class="iconfont icon-yudingdan"></i>
                            </div>
                            <div>
                                <span class="til">预约号</span><br>
                                <span class="info">{{Code}}</span>
                            </div>
                        </div>
                        <div class="orderNo">
                            <span class="til">价格</span><br>
                            <span class="info">{{OrderDetailsList.Currency}}{{OrderDetailsList.TotalAmount}}</span>
                        </div>
                        <div class="order-state">
                            <span class="til">订单状态</span><br>
                            <span class="info" v-if="OrderDetailsList.Status==0">无效单</span>
                            <span class="info" v-else-if="OrderDetailsList.Status==2">已锁定</span>
                            <span class="info" v-else-if="OrderDetailsList.Status==9">新单</span>
                            <span class="info" v-else-if="OrderDetailsList.Status==8">取消单</span>
                            <span class="info" v-else-if="OrderDetailsList.Status==10">已确认</span>
                            <span class="info" v-else-if="OrderDetailsList.Status==27">可入住</span>
                            <span class="info" v-else-if="OrderDetailsList.Status==28">已入住</span>
                            <span class="info" v-else-if="OrderDetailsList.Status==29">已离店</span>
                            <span class="info" v-else-if="OrderDetailsList.Status==30">罚金取消</span>
                            <!-- <span class="info" v-if="OrderDetailsList.Status == 8">已取消</span>
                            <span class="info" v-if="OrderDetailsList.Status ==9||OrderDetailsList.Status == 10">预约中</span>
                            <span class="info" v-if="OrderDetailsList.Status >= 27">预约成功</span> -->
                        </div>
                        <!-- <div class="pay-state">
                            <span class="til">支付状态</span><br>
                            <span class="info" v-if="OrderDetailsList.Status == 8">已退款</span>
                            <span class="info" v-if="OrderDetailsList.Status ==9||OrderDetailsList.Status == 10||OrderDetailsList.Status >= 27">已支付</span>
                        </div> -->
                        <!-- <div class="orderNo" >
                            <span class="til">结算方式</span><br>
                            <span class="info" v-if="OrderDetailsList.SettlementType == 1">单单清</span>
                          <span class="info" v-if="OrderDetailsList.SettlementType == 7">预付款支付</span>
                            <span class="info" v-if="OrderDetailsList.SettlementType != 1&&OrderDetailsList.SettlementType != 7">信贷支付</span>
                        </div> -->
                        <div class="creat-order-date">
                            订单来源：{{OrderDetailsList.Source==0?'手机订房易':OrderDetailsList.Source==1?'PC 端订房易':OrderDetailsList.Source==2?'线下客服':OrderDetailsList.Source==3?'API':''}}<br>
                            下单时间：{{OrderDetailsList.BookingOn|dateLong}}
                        </div>
                    </div>
                </div>
                <div class="main">
                    <div class="about">
                        <div class="title">订单详情</div>
                        <table>
                            <tbody>
                            <tr>
                                <td>产品名称：</td>
                                <td colspan="3">{{OrderDetailsList.HotelName}}</td>
                            </tr>
                            <tr>
                                <td>产品类型：</td>
                                <td>{{OrderDetailsList.RoomName}}</td>
                                <td>产品政策</td>
                                <td>{{OrderDetailsList.RPName}}</td>
                            </tr>
                            <tr>
                                <td>入住时间</td>
                                <td>{{OrderDetailsList.CheckInStr|dateToYMDline}}</td>
                                <td>离店时间</td>
                                <td>{{OrderDetailsList.CheckOutStr|dateToYMDline}}</td>
                            </tr>
                            <tr>
                                <td>入住人</td>
                                <td><span v-for="item in OrderDetailsList.Guest">{{item.FirstName}}{{item.LastName}},</span></td>                                <td>间数</td>
                                <td>{{OrderDetailsList.RoomCount}}</td>
                            </tr>
                            <tr>
                                <td>主订单号</td>
                                <td>{{QGOrderNo}}</td>
                                <td>预约号</td>
                                <td>{{Code}}</td>
                            </tr>
                            <tr>
                                <td v-if="OrderDetailsList.CanCancel">取消条款</td>
                                <td v-if="OrderDetailsList.CanCancel">最晚取消时间：{{OrderDetailsList.CancelDate|dateLong}} <span @click="cancelOrder(OrderDetailsList.Token)" class="order-btn" style="margin-left: 40px;font-size: 16px" v-if="OrderDetailsList.CanCancel">去取消</span></td>
                                <td>特殊要求</td>
                                <td colspan="3">{{OrderDetailsList.Remark!=''?OrderDetailsList.Remark:'无'}}</td>
                                <!---->
                            </tr>
                            
                            </tbody>
                        </table>
                    </div>
                    <div class="contact">
                        <div class="title">价格详情</div>
                        <table>
                            <thead>
                            <tr>
                                <td>入住时间</td>
                                <td>间数</td>
                                <td>含早情况</td>
                                <td>币种</td>
                                <td>金额</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in OrderDetailsList.Details">
                                <td>{{item.CheckIn|dateToYMDline}}</td>
                                <td>{{item.RoomCount}}</td>
                                <td>{{item.Breakfast}}</td>
                                <td>{{item.Currency}}</td>
                                <td>{{item.Price.toFixed(2)}}</td>
                            </tr>
                            <tr>
                                <td>房价小计</td>
                                <td colspan="4">{{OrderDetailsList.Currency}} {{(roomTotalAmount)|numberFloatDel}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="contact" v-if="SurchargesShow">
                        <table>
                            <thead>
                            <tr>
                                <td>附加费用类型</td>
                                <td>时间</td>
                                <td>数量</td>
                                <td>币种</td>
                                <td>单价</td>
                                <td>总价</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in OrderDetailsList.Surcharges">
                                <td>{{item.Name}}</td>
                                <td>{{item.DateStr}}</td>
                                <td>{{item.Num}}</td>
                                <td>{{item.Currency}}</td>
                                <td>{{item.Price.toFixed(2)}}</td>
                                <td>{{(parseInt(item.Price)*parseInt(item.Num)).toFixed(2)}}</td>
                            </tr>
                            <tr>
                                <td>附加费用小计</td>
                                <td colspan="5">{{OrderDetailsList.Currency}}{{SurchargesPrice.toFixed(2)}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="contact">
                        <div class="title">酒店信息</div>
                        <table>
                            <tbody>
                            <tr>
                                <td>酒店电话</td>
                                <td>{{OrderDetailsList.HotelPhone||''}}</td>
                            </tr>
                            <tr>
                                <td>酒店地址</td>
                                <td>{{OrderDetailsList.HotelAddress||''}}</td>
                            </tr>
                            </tbody>
                        </table>

                    </div>
                    <div class="contact">
                        <div class="title">联络人信息</div>
                        <table>
                            <tbody>
                            <tr>
                                <td>贵司操作员</td>
                                <td>{{OrderDetailsList.Creator}}</td>
                            </tr>
                            <tr>
                                <td>CN跟单人</td>
                                <td>{{OrderDetailsList.Oper}}({{OrderDetailsList.Phone}})</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="seal">
                            <img src="../../../assets/img/newydz.png" height="87" width="126"/>
                            <img src="../../../assets/img/chapter.png" height="87"/>
                        </div>
                        <div class="print-time">打印时间：{{PrintDate|dateLong}}</div>
                    </div>
                </div>
                <div class="main tips">
                    <div class="contact">
                        <div>
                            郑重提示： 以上优惠价不供网上销售，请告知客人在前台报姓名入住，切勿说出在网上预订，以免出现不能入住的情况！
                            <br>
                            尊敬的客户，您在本社的客户编号为:{{userInfo.CustomerNO}},为了提供更优质快捷的预订服务，在您查询或预订时，请提供您的客户编号，非常感谢您的配合，谢谢！
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false" @ok="cancel"></Modal>
    </div>
</template>

<script>
    import Loading from '../../../common/cmpnt/Loading/Loading.vue'//缓冲
    import Modal from '../../../common/cmpnt/Modal/modal'

    export default {
        name: "order-Details",
        components:{
            Loading,
            Modal
        },
        data: function () {
            return {
                isLoading:false,
                OrderDetailsList:'',
                isPrint:false,
                userInfo: this.dao.get('userInfo'),
                PrintDate:new Date(),
                roomTotalAmount:0,
                RoomPrice:0,
                SurchargesPrice:0,
                SurchargesShow:false,
                qr:'',
                modal:{
                    show:false,
                    config:{}
                },
                cancelToken:'',
                Code:'',
                QGOrderNo:''
            }
        },
        created() {

        },
        mounted() {
            var that = this
            document.title='【'+this.$route.query.OrderNO+'】'+'订单详情';
            this.Code = this.$route.query.Code
            this.QGOrderNo = this.$route.query.QGOrderNo
            this.initData();
            // this.getQR()
            this.printDate();
            that.$nextTick(() => {
                if(localStorage.getItem('lang')=='t'){
                    that.$zh_tran(localStorage.getItem('lang'))
                }         
            })
        },
        methods: {
            cancel(){
                var that = this;
                that.modal.show = false;
                that.isLoading = true;
                that.postRequest({
                    url: that.Api.cancelOrder,
                    params: that.cancelToken
                }).then(res => {
                    if (res.IsSuccess) {
                        that.initData()
                    } else {
                        that.error({title: '提示', content: res.Msg || '取消失败'});
                    }
                });
            },
            getQR(){
                var that = this;
                that.getRequest({
                    url: that.Api.qr+'?orderNO='+that.$route.params.orderNO,
                    params: ''
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.qr = 'data:image/jpg;base64,'+ res.Result
                    } else {
                        // $state.complete();
                    }
                });
            },
            jSurchargesPrice(list){
                if (list.length==0){
                    return
                }
                var z = 0;
                for (let i = 0; i<list.length; i++){
                    z += parseInt(list[i].Price)*parseInt(list[i].Num)
                }
                this.SurchargesPrice = z
            },
            jRoomPrice(list){
                if (list.length==0){
                    return
                }
                var z = 0;
                for (let i = 0; i < list.length; i++){
                    z += parseInt(list[i].Price)
                }
                this.RoomPrice = z;
            },
            printDate(){
                var that = this;
                var i = setInterval(function () {
                    that.PrintDate = new Date()
                },1000)
            },
            routerBookComfirm(orderNO){
                var that = this;
                var obj={
                    From:1,
                    HotelName:that.OrderDetailsList.HotelName,
                    RoomName:that.OrderDetailsList.RoomName,
                    RPName:'',
                    CheckIn:that.OrderDetailsList.CheckIn,
                    CheckOut:that.OrderDetailsList.CheckOut,
                    RoomCount:that.OrderDetailsList.RoomCount,
                    AdultCount:'',
                    Star:'',
                    HotelAddress:'',
                    HotelPhone:'',
                    AdultPrice:that.OrderDetailsList.TotalAmount,
                    days:that.OrderDetailsList.NightCount,
                    Token:'',
                    CancelPolicy:'',
                    Breakfast:'',
                    Currency:'',
                    Tip:'',
                    Stock:'',
                    MaxPerson:'',
                    Breakfast:'',
                    DailyRates:'',
                    IsAskRoom:'',
                    details:'',
                    room:''
                }
                if(this.OrderDetailsList.OrderType==3){


                    that.$router.push('/ticketBookComfirm?OrderNO='+orderNO)
                }else{
                    that.dao.set('bookInfo',obj);
                    that.$router.push('/bookComfirm?OrderNO='+orderNO)
                }

            },
            cancelOrder(token){
                if(!token){
                    return
                }
                var that = this;
                var params = {
                    Token:token
                }
                that.cancelToken = params
                that.modal={
                    show:true,
                    content:'确定要取消订单号:"' + that.$route.params.orderNO + '"的订单吗?',
                    yes:'确定',
                    no:'取消',
                    isComfirm:true
                }
            },
            printBtn(){
                this.isPoint = true;
                document.getElementsByClassName('to-print-btn')[0].style.display = 'none'
                let subOutputRankPrint = document.getElementById('subOutputRank-print1');
                let newContent =subOutputRankPrint.innerHTML;
                let oldContent = document.body.innerHTML;
                document.body.innerHTML = newContent;
                window.print();
                window.location.reload();
                document.body.innerHTML = oldContent;
                document.getElementsByClassName('to-print-btn')[0].style.display = 'block'
                this.isPoint = false;
                return false;
            },
            initData(){
                var that = this;
                that.isLoading = true;
                that.getRequest({
                    url: that.Api.getOrderDetails+'?orderNO='+that.$route.query.OrderNO,
                    params: ''
                }).then(res => {
                    that.isLoading = false;
                    if (res && res.IsSuccess) {
                        that.OrderDetailsList = res.Result
                        that.OrderDetailsList.TotalAmount = that.OrderDetailsList.TotalAmount.toFixed(2);
                        // $state.loaded();
                        if(that.OrderDetailsList.Surcharges.length>0){
                            that.SurchargesShow = true
                        }
                        that.jSurchargesPrice(that.OrderDetailsList.Surcharges);
                        that.jRoomPrice(that.OrderDetailsList.Details);
                        that.getRoomTotalAmount();//房价小计
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }    
                        })
                    } else {
                        // $state.complete();
                    }
                });
            },
            //房价小计
            getRoomTotalAmount(){
                var list=this.OrderDetailsList.Details;
                var total=0;
                list.forEach((item)=>{
                    total+=(item.Price*item.RoomCount)
                })
                this.roomTotalAmount=total;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/package/reserve/details.vue